<template>
  <article>
    <div class="dataForm">
      <div class="dataForm__item">
        <div class="dataForm__name">ID</div>
        <el-input v-model="detail.sid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">标题</div>
        <el-input v-model="detail.desc" placeholder="" size="mini" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">链接</div>
        <el-input  type="textarea" v-model="detail.url" placeholder="" rows="8" size="small" class="dataForm__input"></el-input>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">跳转方式</div>
        <el-radio-group v-model="detail.jump_type">
          <div class="dib mr-20">
            <el-radio :label="1">普通跳转</el-radio>
            <el-radio :label="2">兼容跳转</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">后台展示</div>
        <el-radio-group v-model="detail.display">
          <div class="dib mr-20">
            <el-radio :label="0">不展示</el-radio>
            <el-radio :label="1">展示</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name">状态</div>
        <el-radio-group v-model="detail.status">
          <div class="dib mr-20">
            <el-radio :label="0">失效</el-radio>
            <el-radio :label="1">正常</el-radio>
          </div>
        </el-radio-group>
      </div>
      <div class="dataForm__item mt-16">
        <div class="dataForm__name"></div>
        <button class="blue-large-btn" @click="sjEdit">保存</button>
      </div>
    </div>
  </article>
</template>
<script>
import util from '../../../script/util'
import {sjDetail, sjEdit} from '../../../api/api'
export default {
  name: 'sjEdit',
  data () {
    return {
      detail: {
        sid: 0,
        desc: '',
        url: '',
        jump_type: 1,
        display: 1,
        status: 1
      },
      dialog: false,
      statusList: [
        {
          name: '失效',
          value: 0
        },
        {
          name: '正常',
          value: 1
        }
      ]
    }
  },
  methods: {
    // 公众号详情
    sjDetail () {
      let params = {
        sid: this.detail.sid
      }
      this.loading = true
      sjDetail(params).then((res) => {
        let data = res.data || {c: -1}
        console.log(data)
        if (!data.c) {
          this.detail = data.d.sj
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
        this.loading = false
      })
    },
    sjEdit () {
      let content = ''
      if (this.detail.desc === '') {
        content = '请填写标题'
      }
      if (this.detail.url === '') {
        content = '请填写链接'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      let params = util.cloneObj(this.detail)
      sjEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.$router.push('/sjList')
        } else {
          this.$notify({
            title: '失败',
            message: '服务器出错了',
            type: 'error'
          })
        }
      })
    }
  },
  mounted () {
    this.detail.sid = parseInt(this.$route.query.sid || 0)
    if (this.detail.sid) {
      this.sjDetail()
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/sj/sjEdit.vue